import * as React from 'react';
import type { InjectedIntlProps } from 'react-intl';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { TRACK_EVENT_TYPE } from '@atlassian/analytics-web-react';
import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { ReadOnlyReason } from '@atlassian/proforma-common-core/jira-common-models';
import type { FormValidationResult } from '@atlassian/proforma-common-core/jira-common-models';
import SectionMessage from '@atlaskit/section-message';
import { SectionMessageContainer } from './styled';

interface RequestTypeProformaErrorProps {
    portalId: number;
    requestTypeId: number;
    admin: boolean;
    formValidationResult?: FormValidationResult;
}

type Props = RequestTypeProformaErrorProps & WithAnalyticsEventsProps & InjectedIntlProps;

export class RequestTypeProformaError extends React.Component<Props> {
    fireRequestTypeViewedTrackEvent = () => {
        const { createAnalyticsEvent, requestTypeId, portalId, formValidationResult } = this.props;

        if (!createAnalyticsEvent) return;

        let analyticsReason: string | undefined;
        if (formValidationResult?.readOnlyMandatory.length) {
            analyticsReason = 'readOnlyMandatory';
        } else if (formValidationResult?.isConditionallyShown.length) {
            analyticsReason = 'isConditionallyShown';
        }
        const analyticsEvent = createAnalyticsEvent({
            portalId,
            requestTypeId,
            analyticsType: TRACK_EVENT_TYPE,
            action: 'stopped',
            actionSubject: 'formValidation',
            stopReason: analyticsReason,
        });
        analyticsEvent.fire();
    };

    componentDidMount() {
        this.fireRequestTypeViewedTrackEvent();
    }

    render() {
        const { admin, intl, formValidationResult } = this.props;

        let errorMessage;

        if (
            formValidationResult?.readOnlyMandatory.some(
                ({ readOnlyReason }) => readOnlyReason === ReadOnlyReason.Anonymous
            )
        ) {
            errorMessage = intl.formatMessage(messages.couldntLoadRequestAnonymousDescription);
        } else if (
            formValidationResult?.readOnlyMandatory.some(
                ({ readOnlyReason }) => readOnlyReason === ReadOnlyReason.Unlicensed
            )
        ) {
            errorMessage = intl.formatMessage(messages.couldntLoadRequestUnlicensedDescription);
        } else if (admin && formValidationResult?.isConditionallyShown.length) {
            errorMessage = intl.formatMessage(messages.couldntLoadRequestConditionalSectionDescription);
        } else {
            errorMessage = intl.formatMessage(messages.couldntLoadRequestGenericDescription);
        }

        return (
            <SectionMessageContainer>
                <SectionMessage appearance="error" title={intl.formatMessage(messages.couldntLoadRequestTitle)}>
                    {errorMessage}
                </SectionMessage>
            </SectionMessageContainer>
        );
    }
}
export default injectIntl(withAnalyticsEvents()(RequestTypeProformaError));
